var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-not-initialized"},[_c('div',{staticStyle:{"font-size":"30px","display":"none"}},[_vm._v(" "+_vm._s(_vm.translate(_vm.section.title))+" ")]),_c('DialogResourceSuggestions',{attrs:{"section":_vm.section}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }